/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './CarrosEletricosBannerSemanaCliente.css';
import RedButton from '@/components/atoms/RedButton';

function CarrosEletricosBannerSemanaCliente() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 599 && (
                  <img
                    src="assets/semana-consumidor-set26/banner-320.png"
                    alt="Banner da Semana do Cliente para veículos elétricos.  Familia aproveitando a condição especial para garantir sua oportunidade de comprar um veículo elétrico com a Santander Financiamentos."
                    className=""
                  />
                )}
                {width > 599 && width <= 700 && (
                  <img
                    src="assets/semana-consumidor-set26/banner-600.png"
                    alt="Banner da Semana do Cliente para veículos elétricos.  Familia aproveitando a condição especial para garantir sua oportunidade de comprar um veículo elétrico com a Santander Financiamentos."
                    className=""
                  />
                )}
                {width > 700 && width <= 992 && (
                  <img
                    src="assets/semana-consumidor-set26/banner-992.png"
                    alt="Banner da Semana do Cliente para veículos elétricos.  Familia aproveitando a condição especial para garantir sua oportunidade de comprar um veículo elétrico com a Santander Financiamentos."
                    className=""
                  />
                )}
                {width > 992 && (
                  <img
                    src="assets/semana-consumidor-set26/banner-1280.png"
                    alt="Banner da Semana do Cliente para veículos elétricos.  Familia aproveitando a condição especial para garantir sua oportunidade de comprar um veículo elétrico com a Santander Financiamentos."
                    className=""
                  />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            {/* <div className="hero-selo">
                <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
              </div> */}
            <div className="hero-texts">
              <h1 className="hero-title">O futuro da mobilidade começa com quem lidera.</h1>
              <h2 className="hero-sub-title">
                Na <b>Semana do Cliente</b>, aproveite condições especiais para veículos elétricos
                com o cupom <strong>CLIENTE10</strong>
              </h2>
            </div>
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Simule agora
              </WhiteButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default CarrosEletricosBannerSemanaCliente;
